const loadView = view => {
  return () =>
    import(/* webpackChunkName: 'viewG-[request]' */ `@GV/Auth/${view}.vue`)
}

export default [
  {
    path: '/',
    name: 'Auth',
    redirect: { name: 'Login' },
    component: loadView('index'),
    children: [
      {
        path: 'Login',
        name: 'Login',
        component: loadView('Login')
      },
      {
        path: 'OtpBinding',
        name: 'OtpBinding',
        component: loadView('OtpBinding')
      },
      {
        path: 'OtpVerify',
        name: 'OtpVerify',
        component: loadView('OtpVerify')
      },
      {
        path: 'OtpReset',
        name: 'OtpReset',
        component: loadView('OtpReset')
      },
      {
        path: 'OtpResetSuccess',
        name: 'OtpResetSuccess',
        component: loadView('OtpResetSuccess')
      },
      {
        path: 'PasswordForget',
        name: 'PasswordForget',
        component: loadView('PasswordForget')
      },
      {
        path: 'PasswordReset',
        name: 'PasswordReset',
        component: loadView('PasswordReset')
      },
      {
        path: 'PasswordResetSuccess',
        name: 'PasswordResetSuccess',
        component: loadView('PasswordResetSuccess')
      }
    ]
  }
]
